import { useState } from 'react'
import { Link } from 'react-router-dom'
import './LandingPage.css'

export default function LandingPage() {
  const [navOpen, setNavOpen] = useState(false)

  return (
    <div className="lp">

      {/* ── NAV ── */}
      <nav className="lp-nav">
        <div className="lp-container">
          <a href="#top" className="lp-nav-brand">SIGLAT <span>KONSTRACT</span> OPC</a>

          <button
            className="lp-nav-toggle"
            aria-label="Menu"
            onClick={() => setNavOpen((o) => !o)}
          >
            <span /><span /><span />
          </button>

          <div className={`lp-nav-links${navOpen ? ' open' : ''}`}>
            <a href="#services" onClick={() => setNavOpen(false)}>Services</a>
            <a href="#projects" onClick={() => setNavOpen(false)}>Projects</a>
            <a href="#research" onClick={() => setNavOpen(false)}>Research</a>
            <a href="#about"    onClick={() => setNavOpen(false)}>About</a>
            <a href="#contact"  onClick={() => setNavOpen(false)}>Contact</a>
            <Link to="/book" className="lp-nav-book" onClick={() => setNavOpen(false)}>Book a Repair</Link>
          </div>
        </div>
      </nav>

      {/* ── HERO ── */}
      <section id="top" className="lp-hero">
        <div className="lp-container">
          <div className="lp-hero-eyebrow">
            <span className="lp-pill">General Repair</span>
            <span className="lp-pill">MEPS Works</span>
          </div>

          <h1>Fast. Documented.<br /><span>Warranted.</span></h1>

          <p className="lp-hero-sub">
            Book trusted repair workers in minutes. Licensed engineers behind every job.
            30-day warranty on all completed work.
          </p>

          <div>
            <Link to="/book" className="lp-cta-primary">
              BOOK A REPAIR NOW →
            </Link>
            <a href="#services" className="lp-cta-secondary">See our services ↓</a>
          </div>

          <div className="lp-trust-badges">
            <span className="lp-badge">Licensed Civil Engineer (RCE)</span>
            <span className="lp-badge">Registered Master Plumber (RMP)</span>
            <span className="lp-badge">Siglat Konstract OPC</span>
          </div>
        </div>
      </section>

      {/* ── HOW IT WORKS ── */}
      <section className="lp-hiw">
        <div className="lp-container">
          <p className="lp-section-eyebrow">How It Works</p>
          <h2>Three steps. No guesswork.</h2>

          <div className="lp-steps">
            <div className="lp-step">
              <div className="lp-step-num">01</div>
              <h3>Describe Your Problem</h3>
              <p>Fill our guided 5-step form. Tell us what, where, when, and any access requirements.</p>
            </div>
            <div className="lp-step">
              <div className="lp-step-num">02</div>
              <h3>Get an Instant Scope Estimate</h3>
              <p>Our system generates a professional scope of work and cost estimate immediately — no waiting.</p>
            </div>
            <div className="lp-step">
              <div className="lp-step-num">03</div>
              <h3>Confirm and We Dispatch</h3>
              <p>Review the estimate, request your final proposal, sign the contract, and we send a verified worker to your door.</p>
            </div>
          </div>

          <div className="lp-hiw-cta">
            <Link to="/book" className="lp-cta-link">Get Your Free Estimate →</Link>
          </div>
        </div>
      </section>

      {/* ── WHY SIGLAT ── */}
      <section className="lp-why">
        <div className="lp-container">
          <p className="lp-section-eyebrow">Why Siglat Konstract</p>
          <h2>Not a handyman platform. An engineering firm.</h2>

          <div className="lp-why-grid">
            <div className="lp-why-card">
              <h3>Licensed Engineering Firm</h3>
              <p>Every job is backed by a Licensed Civil Engineer (RCE) and Registered Master Plumber (RMP). Not a random handyman — a professional engineering firm.</p>
            </div>
            <div className="lp-why-card">
              <h3>Full Documentation on Every Job</h3>
              <p>Scope of work, signed contract, before and after photos, materials receipts, completion certificate, and warranty document — standard on every single job.</p>
            </div>
            <div className="lp-why-card">
              <h3>30-Day Warranty</h3>
              <p>All workmanship warranted for 30 days from completion. If it fails — we fix it. No arguments.</p>
            </div>
            <div className="lp-why-card">
              <h3>Transparent Pricing</h3>
              <p>You see the complete scope estimate before committing. No surprise charges. Additional work requires your explicit approval before it proceeds.</p>
            </div>
          </div>
        </div>
      </section>

      {/* ── EXISTING CONTENT (navy theme) ── */}
      <div className="lp-classic">

        {/* SERVICES */}
        <section id="services" className="lp-section">
          <div className="lp-container">
            <p className="lp-section-label">Services</p>
            <h2>What We Do</h2>
            <p className="lp-services-intro">
              From routine repairs to complex structural work — Siglat Konstract handles it all with engineering precision.
              Our work concentrates where the consequences of getting it wrong are highest — seismic zones, corroded structures,
              occupied facilities, and hard deadlines.
            </p>

            <div className="lp-service">
              <h3>General Construction and Execution <span className="lp-repair-badge">Repairs Available</span></h3>
              <p>Residential houses, warehouses, industrial buildings. Design through construction. We build what we design, and we design what we know how to build. No gap between the drawing and the field.</p>
            </div>

            <div className="lp-service">
              <h3>Material Supply and Procurement</h3>
              <p>Structural steel, reinforcing bar, and construction materials — sourced and delivered to project sites. We leverage direct supplier relationships to control cost, lead time, and material certification for our projects.</p>
            </div>

            <div className="lp-service">
              <h3>Structural Assessment and Design</h3>
              <p>New structural design for residential, commercial, and industrial buildings. Existing structure assessment when the original drawings are missing, the steel is corroded, or the loads have changed since the building was built. We measure what's there, model what it does, and determine what it can carry — with real numbers, not assumptions.</p>
            </div>

            <div className="lp-service">
              <h3>Seismic Vulnerability Assessment and Retrofit Design</h3>
              <p>Evaluation of existing structures against NSCP 2015 seismic provisions. Retrofit design for steel and concrete buildings in Seismic Zone 4 — including connection redesign, knee brace systems, RC pedestal encasement, and progressive collapse assessment. We design retrofits that can be built while the building stays operational.</p>
            </div>

            <div className="lp-service">
              <h3>Emergency Structural Repair and Stabilization</h3>
              <p>When a structure has partially failed and needs immediate intervention — temporary bracing design, load redistribution analysis, phased repair sequencing. We've done this under emergency timelines on structures that were surviving on residual capacity alone. Every repair sequence is designed so that no construction phase creates a condition worse than the existing damage.</p>
            </div>

            <div className="lp-service">
              <h3>Construction Management and Project Delivery</h3>
              <p>We manage construction on projects where the structural work is the critical path — retrofit installations, renovation within operating facilities, and fast-track delivery where schedule is not negotiable. Background in Ayala Land Premier high-rise construction, where the tolerance for finished deliverables and zero-defect handover is the baseline, not the aspiration.</p>
            </div>
          </div>
        </section>

        {/* PROJECTS */}
        <section id="projects" className="lp-section">
          <div className="lp-container">
            <p className="lp-section-label">Projects</p>
            <h2>Selected Work</h2>

            <article className="lp-project">
              <h3>Seismic Retrofit — Chlorine Warehouse, Mauban, Quezon</h3>
              <p>Five steel columns detached from their bases. Five more corroded to partial section loss. A chlorine storage facility in Seismic Zone 4 that was standing only because the roof diaphragm was redistributing loads the original design never anticipated. No as-built drawings. No site visit allowed before design. Emergency timeline.</p>
              <p>We designed the complete retrofit: RC pedestal encasement with boot plate connections, knee brace lateral stiffening at 70° angle, 42 MPa high-early-strength concrete for schedule, and a phased construction sequence limiting work to two columns simultaneously. Every temporary bracing stage was designed for full gravity load plus a 2.0 dynamic impact factor. Anchor bolt connections verified per ACI 318-14 Chapter 17 with concrete breakout capacity confirmed at D/C = 0.39. Progressive collapse assessment identified the knee braces as providing an unintended but significant alternate load path for future column base deterioration — the same mechanism that caused the original failure. The structure was repaired without incident.</p>
              <p className="lp-client">Client: Advanced Matrix Construction Inc. for Quezon Power (Philippines) Ltd.</p>
            </article>

            <article className="lp-project">
              <h3>High-Rise Residential Construction — Ayala Land Premier</h3>
              <p>Construction experience on Arbor Lanes and Alveo high-rise residential towers. Ayala Land Premier projects operate at a quality standard that most Philippine contractors never encounter — architectural concrete tolerances of 3mm over a 3-meter straightedge, zero-defect unit handover, and a QA culture where "good enough" does not exist.</p>
              <p>This background informs everything we do at Siglat Konstract. We brought ALP-grade discipline to industrial retrofit and warehouse construction because precision is a habit, not a project-specific decision.</p>
            </article>

            <article className="lp-project">
              <h3>Residential and Warehouse Design-Build</h3>
              <p>Single and multi-family residential structures. Steel and concrete warehouse buildings. Full service from structural design through construction and turnover.</p>
            </article>
          </div>
        </section>

        {/* RESEARCH */}
        <section id="research" className="lp-section">
          <div className="lp-container">
            <p className="lp-section-label">Research</p>
            <h2>Technical Publications</h2>
            <p>We publish original engineering work. These are not brochures — they are structural calculations, verified analysis, and design methodologies based on real problems.</p>

            <div className="lp-pub">
              <h3>Through-Truss Mezzanine System for Long-Span Column-Free Office Floors in Existing Steel Portal Frame Warehouses</h3>
              <p>A structural feasibility study investigating a novel framing concept for 30-meter clear span mezzanines inside existing portal frame warehouses. The through-truss system places the primary structure above the mezzanine floor — using the unused roof volume as structural depth — achieving vibration compliance per AISC Design Guide 11 at spans where conventional below-floor systems fail. Combined system natural frequency: 11.2 Hz. Peak walking acceleration: 0.005% g. Full member design per AISC 360-16, NSCP 2015, and ACI 318-14.</p>
              <p><a href="/through-truss-mezzanine-feasibility-study.pdf" target="_blank" rel="noopener noreferrer">Download the study (PDF)</a></p>
            </div>

            <div className="lp-pub">
              <h3>Emergency Seismic Retrofit of Corroded Steel Columns — A Case Study from Mauban, Quezon</h3>
              <p>(In preparation) — Documenting the structural assessment, retrofit design, and construction of the chlorine warehouse column restoration. Includes modal analysis comparison (intact vs. damaged vs. retrofitted), anchor bolt connection verification, progressive collapse assessment, and an honest discussion of what was learned and what would be done differently.</p>
              <p>Publication expected 2026.</p>
            </div>
          </div>
        </section>

        {/* ABOUT */}
        <section id="about" className="lp-section">
          <div className="lp-container">
            <p className="lp-section-label">The Engineer</p>
            <h2>About</h2>
            <p>Siglat Konstract OPC is a one-engineer structural consultancy. The principal is Engr. Gabriel C. Mempin — licensed Civil Engineer (RCE) and Registered Master Plumber (RMP), with project experience spanning high-rise residential construction, industrial facility renovation, and emergency structural retrofit.</p>

            <p>Siglat Konstract now offers on-demand repair services through its digital platform — bringing the same engineering discipline that governs large-scale retrofit projects to residential and commercial repair work. Book online, get a documented scope and cost estimate, and have a verified worker dispatched to your property.</p>

            <p>The firm operates on three principles that are not negotiable:</p>

            <div className="lp-principles">
              <div className="lp-principle">
                <p><strong>Engineering from first principles.</strong> We use ETABS, SAP2000, and every tool available. But we understand what the software is doing before we trust its output. The structural behavior governs the design — the software verifies it. When the model says something that contradicts the physics, we fix the model, not the physics. Current self-directed study includes Chopra's <em>Dynamics of Structures</em> and Clough &amp; Penzien's <em>Dynamics of Structures</em> — because seismic retrofit demands understanding dynamics at the equation level, not just the button level.</p>
              </div>

              <div className="lp-principle">
                <p><strong>Honest assessment, even when it's uncomfortable.</strong> We tell clients what the structure can and cannot do. We don't inflate capacity to win a project, and we don't add unnecessary conservatism to avoid thinking. If a building needs ₱5M in foundation work, we say that. If it needs ₱500K, we say that too. The numbers are what they are.</p>
              </div>

              <div className="lp-principle">
                <p><strong>Construction-informed design.</strong> Every detail we draw has to survive contact with a real contractor, real weather, and real material availability in the Philippines. We design for the field, not for the plan checker's desk. If a connection can't be welded in position at 8 meters above the floor with a stick welder, we don't draw it.</p>
              </div>
            </div>

            <p>Siglat Konstract works with a network of licensed architects, MEP engineers, and specialist consultants. When a project requires disciplines beyond structural engineering, we assemble the right team — but the structural work stays in-house, under our seal, with our name on it.</p>

            <p>Based in the Philippines. Working within 100 km of Manila, with capacity for projects nationwide when the engineering demands it.</p>
          </div>
        </section>

        {/* CONTACT */}
        <section id="contact" className="lp-section">
          <div className="lp-container">
            <p className="lp-section-label">Get in touch</p>
            <h2>Contact</h2>
            <p>If you have a structural problem that needs solving — or a project that needs an engineer who shows up, does the work, and delivers what was promised — send us a message.</p>

            <div className="lp-contact-info">
              <p><strong>Email:</strong> <a href="mailto:office@siglatkonstract.com">office@siglatkonstract.com</a></p>
              <p><strong>Phone:</strong> <a href="tel:+639456086917">+63 945 608 6916</a></p>
              <p><strong>Office:</strong> 407 Sampaguita St. GM Homes Almanza Uno Las Piñas City</p>
            </div>

            <p className="lp-contact-note">We respond within 24 hours. If the problem is urgent, call directly.</p>
          </div>
        </section>

        {/* FOOTER */}
        <footer className="lp-footer">
          <div className="lp-container">
            <p>&copy; 2026 Siglat Konstract OPC. All rights reserved.</p>
          </div>
        </footer>

      </div>

      {/* ── MOBILE FLOATING BUTTON ── */}
      <Link to="/book" className="lp-float">
        BOOK NOW →
      </Link>

    </div>
  )
}
